<app-top-bar></app-top-bar>
<app-offline-elem *ngIf="muestraOffline==true"></app-offline-elem>
<app-loading-elem *ngIf="muestraLoading==true"></app-loading-elem>
<app-msgbox-elem *ngIf="muestraMsgbox==true"></app-msgbox-elem>
<app-combo-elem *ngIf="muestraCombo==true"></app-combo-elem>
<app-datepick-elem *ngIf="muestraDatepick==true"></app-datepick-elem>
<app-dropdown-elem *ngIf="muestraDropdown==true"></app-dropdown-elem>
<app-selectbox-elem *ngIf="muestraSelectbox==true"></app-selectbox-elem>

<div>
	<router-outlet></router-outlet>
</div>
<app-footer></app-footer>